export default () => {
  let searchArea = $('#searchArea');

  $('.mobile-menu-navigation__search.siteSearch__trigger').on('click', function (evt) {
    evt.preventDefault();

    $('.main-menu .mobile-menu-navigation__trigger').removeClass('is-active').addClass('is-disabled');
    $('.main-menu ul').removeClass('is-active');

    $('.main-menu').toggleClass('is-active');

    $('.siteSearch__trigger').toggleClass('is-active');
    $('.u-search-container').toggleClass('is-active');
  });

  $('li.desktop-navigation__search .siteSearch__trigger').on('click', function (evt) {
    evt.preventDefault();
    console.log('frog');
    $('.siteSearch__trigger').toggleClass('is-active');
    $('.u-search-container').toggleClass('is-active');
  });

  searchArea.on('focus', function() {
    this.placeholder = '';
  });

  searchArea.on('blur', function() {
    if (this.value === '') {
      this.placeholder = 'Search by part or keyword...then press enter';
    }
  })

}



// WEBPACK FOOTER //
// ./themes/app/assets/js/modules/search.js